module.exports = __webpack_public_path__ + "img/search-link.f4e32baa.png";